import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQueryWithReauth';

export interface Quote {
  id: string;
  title: string;
  status: string;
}

export const quotesApi = createApi({
  reducerPath: 'quotesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Quote'],
  endpoints: (builder) => ({
    getQuotes: builder.query<Quote[], void>({
      query: () => ({ url: '/quotes' }),
      providesTags: ['Quote'],
    }),
    getQuote: builder.query<Quote, string>({
      query: (id) => ({ url: `/quotes/${id}` }),
      providesTags: ['Quote'],
    }),
    createQuote: builder.mutation<Quote, { customer_id: string; title: string; items: any[] }>(
      {
        query: (body) => ({
          url: '/quotes',
          method: 'POST',
          body,
        }),
        invalidatesTags: ['Quote'],
      }
    ),
  }),
});

export const {
  useGetQuotesQuery,
  useGetQuoteQuery,
  useCreateQuoteMutation,
} = quotesApi;
